module.exports = __webpack_public_path__ + "static/media/icon-star.9e54355c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-star.svg
// module id = 1256
// module chunks = 19